import './chart-governance.scss';

/**
 * version    1.0
 * class      <type> (ChartGovernance)
 */
export class ChartGovernance {}
